import { Row } from '@/app/components/Flex/Flex'
import { Layout } from '@/app/components/Layout/Layout'
import { LocationFormPage } from '@/app/components/LocationFormPage/LocationFormPage'
import { Motion } from '@/app/components/Motion/Motion'
import { UI } from '@/app/components/UI/UI'
import { useBack } from '@/app/hooks/useBack'
import { useSession } from '@/app/state/session'
import type { FunctionalComponent } from 'preact'

export const LocationPage: FunctionalComponent<{
  path?: string
}> = () => {
  const patchProfile = useSession(s => s.patchProfile)
  const back = useBack('/settings')

  return (
    <Layout>
      <Layout.Content
        onBack={back}
      >
        <Motion>
          <Layout.Header>
            Место рождения
          </Layout.Header>

          <Row gap={15}>
            <LocationFormPage
              onSelect={async location => (
                patchProfile({
                  profile: {
                    location,
                  },
                }).then(back)
              )}
            />

            <UI.Button
              size='l'
              type='secondary'
              onClick={back}
            >
              Назад
            </UI.Button>
          </Row>
        </Motion>
      </Layout.Content>
    </Layout>
  )
}
